import { safeGet } from '../functions';

// eslint-disable-next-line
export async function response(promise, defaultValue = null) {
  return safeGet(await promise, ['response', 'data', 'data'], defaultValue);
}
